import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDeletePlace(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete('/place/v1/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
          },
        fetchPropertitypin(ctx, queryParams){

            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                
                axios
                .post('cache-master/v1/place-filter', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        
        },
        fetchNearBy(ctx, queryParams){

            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                
                axios
                .post('place/v1/near-by', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        
        },
        fetchTransit(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/transit/v1/filterByType`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchZone(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/zone/v1/zoneData`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchBuilding(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .get(`/place/v1/get-building/${data}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        AddBuilding(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/add-building`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
         updateOrderingCountBuilding(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/update-orderingcoung-building`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateBuilding(ctx,queryParams){
             var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/update-building/`+queryParams.id, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
        deleteBuilding(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/place/v1/remove-building/${queryParams.id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        AddFloorplan(ctx, queryParams){
            // var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/floorplan/add`, queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteFloorplan(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/place/v1/floorplan/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        orderingFloorplan(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/floorplan/ordering`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        orderingBuilding(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/place/v1/ordering-building`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/faq/v1/add`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        fetchFAQs(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                .post(`/faq/v1/get`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/faq/v1/update`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        updateOrderingFAQ(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/faq/v1/updateOrdering`, data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteFAQ(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                .delete(`/faq/v1/delete/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}